<template>
  <div class="bootsrap-scope">
    <!-- To simulate the css tree structure of Bootstrap
     have added a new div with data-bs-theme attribute -->
    <div data-bs-theme="dark">
      <div class="body d-flex flex-column flex-lg-row min-vh-100">
        <NavigationMenu :display-name="displayName" />

        <main class="flex-grow-1 p-4 overflow-y-auto vh-100">
          <GlobalProgressBar />
          <GlobalToast />
          <BreadCrumb />

          <AppProgressBar v-if="isLoading" />

          <slot />
        </main>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

import BreadCrumb from '@/components/BreadCrumb.vue';
import AppProgressBar from '@/components/common/AppProgressBar.vue';
import GlobalProgressBar from '@/components/GlobalProgressBar.vue';
import GlobalToast from '@/components/GlobalToast.vue';
import NavigationMenu from '@/components/navigation/NavigationMenu.vue';

type Props = {
  displayName: string;
  isLoading: boolean;
};

defineProps<Props>();
</script>

<style lang="scss" scoped>
.bootsrap-scope .body {
  font-family: var(--bs-body-font-family);
  font-size: var(--bs-body-font-size);
  font-weight: var(--bs-body-font-weight);
  line-height: var(--bs-body-line-height);
  color: var(--bs-body-color);
  text-align: var(--bs-body-text-align);
  background-color: var(--bs-body-bg);
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: transparent;
  margin: 0;
}
</style>
